// Labels and formatters of the dispatch board and "Mein Tag".
import { qualificationLabels } from "../safety/format";
import { berlinParts, minutesToClock } from "./calc";

export const clockOf = value => minutesToClock(berlinParts(value).minutes);

export const timeRange = item => `${clockOf(item.start)}–${clockOf(item.end)}`;

/** "Mo 12.10." in the user's language. */
export const dayLabel = (day, lng, { long = false } = {}) =>
  new Date(`${day}T12:00:00Z`).toLocaleDateString(lng || "de-DE", {
    weekday: long ? "long" : "short",
    day: "2-digit",
    month: "2-digit",
    timeZone: "UTC"
  });

export const kindLabels = t => ({
  appointment: t("Appointment"),
  manual: t("Job"),
  project: t("Project work"),
  maintenance: t("Maintenance visit"),
  task: t("Task")
});

export const absenceLabels = t => ({
  leave: t("Leave"),
  sick: t("Sick"),
  school: t("Vocational school")
});

export { qualificationLabels };

/** One sentence per conflict, from its type and params. */
export const conflictText = (conflict, t) => {
  const p = { ...(conflict.params || {}) };
  if (p.qualification) p.qualification = qualificationLabels(t)[p.qualification] || p.qualification;
  if (p.date) p.date = String(p.date).split("-").reverse().join(".");
  const texts = {
    person_double: t("{{name}} is already booked: {{title}}", p),
    vehicle_double: t("{{vehicle}} is already in use: {{title}}", p),
    tool_double: t("{{tool}} is already in use: {{title}}", p),
    leave: t("{{name}} is on leave", p),
    sick: t("{{name}} is on sick leave", p),
    school: t("{{name}} is at vocational school", p),
    holiday: t("Public holiday: {{label}}", p),
    outside_hours: t("{{name}} is not working at that time (shift / working hours)", p),
    skill_missing: t("{{name}} lacks: {{skills}}", p),
    qualification_missing: t("{{name}}: no record of {{qualification}}", p),
    qualification_expired: t("{{name}}: {{qualification}} expired on {{date}}", p),
    qualification_expiring: t("{{name}}: {{qualification}} expires on {{date}}", p),
    license_missing: t("{{name}} has no driving licence check on record", p),
    license_expired: t("{{name}}: driving licence check overdue since {{date}}", p),
    license_expiring: t("{{name}}: driving licence check due on {{date}}", p),
    license_class: t(
      "{{name}} may not drive this vehicle (needs {{licenseClass}}, has {{classes}})",
      p
    ),
    license_class_unknown: t(
      "{{name}}: licence classes not recorded (vehicle needs {{licenseClass}})",
      p
    ),
    vehicle_inspection: t("{{vehicle}}: inspection (TÜV) overdue since {{date}}", p),
    vehicle_inspection_soon: t("{{vehicle}}: inspection (TÜV) due on {{date}}", p),
    vehicle_seats: t("{{vehicle}} has {{seats}} seats for {{people}} people", p)
  };
  return texts[conflict.type] || conflict.type;
};

export const accuracyHint = (leg, t) =>
  leg.accuracy === "local"
    ? t("same postcode")
    : leg.accuracy === "region"
      ? t("same postcode area, rough estimate")
      : t("straight line × factor, rough estimate");
